import React, { useEffect, useReducer, useRef, useState } from 'react'

import "./custom-tooltip.css"
import { UIProperties } from '../../cvp-webgames-core/Components/ui/UIProperties';
import { BaseConfig } from '../BaseConfig';

const CustomTooltip = (props: UIProperties<TooltipConfig>) => {
	const [isInit, setIsInit] = useState(false);
	const tooltip: any = useRef(null);

	useEffect(() => {
		if(!isInit) {
			setIsInit(true);
			const container = document.getElementById(props.parameters.containerElementId);
			container.classList.add('custom-tooltip-parent');

			container.addEventListener('mouseover', function() {
				tooltip.current.style.visibility = 'visible';
				tooltip.current.style.opacity = 1;
			});

			container.addEventListener('mouseout', function() {
				tooltip.current.style.visibility = 'hidden';
				tooltip.current.style.opacity = 0;
			});
		}
	}, []);

	return (
		<p ref={tooltip} className="modal-disable-select custom-tooltip-ui" style={{
			top: props.parameters.yPos + 'px',
			left: props.parameters.xPos + 'px'
		}}>{props.parameters.text}</p>
	);

};

export interface TooltipConfig extends BaseConfig {
	text: string;
	xPos: number;
	yPos: number;
	containerElementId: string;
}

export default CustomTooltip;